import { adminVaultsService } from '@/services/admin-vaults.service';
import type { AdminFilters } from '@/types/admin.types';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export function useAdminVaults(filters: AdminFilters = {}) {
  return useQuery({
    queryKey: ['admin-vaults', filters],
    queryFn: () => adminVaultsService.getAll(filters),
  });
}

export function useAdminVaultDetail(uuid: string | undefined) {
  return useQuery({
    queryKey: ['admin-vault', uuid],
    queryFn: () => adminVaultsService.getById(uuid!),
    enabled: !!uuid,
  });
}

export function useSuspendVault() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (uuid: string) => adminVaultsService.suspend(uuid),
    onSuccess: () => { toast.success('Coffre suspendu'); qc.invalidateQueries({ queryKey: ['admin-vaults'] }); },
    onError: () => toast.error('Erreur lors de la suspension'),
  });
}

export function useActivateVault() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (uuid: string) => adminVaultsService.activate(uuid),
    onSuccess: () => { toast.success('Coffre activé'); qc.invalidateQueries({ queryKey: ['admin-vaults'] }); },
    onError: () => toast.error("Erreur lors de l'activation"),
  });
}

export function useVaultStorageStats() {
  return useQuery({
    queryKey: ['admin-vault-storage'],
    queryFn: () => adminVaultsService.getStorageStats(),
  });
}
